import { Button, Chip, Link, Box, Grid } from '@mui/material'
import {
  CheckCircleOutlineIcon,
  CloseIcon,
  HomeIcon,
  PhoneIcon,
  PhoneIphoneIcon,
  WorkIcon,
  DragIndicatorIcon,
} from 'components/Icons'
// import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import FeildSkeleton from './FieldSkeleton'
import { useTranslation } from 'react-i18next'
// import { FaLanguage } from 'react-icons/fa'
import { hasFullPermission } from 'store'

export default function ContactsListItem({ item, index, setMovedItemData, itemCount }) {
  // const languages = useSelector(state => state.lookup.languages)
  const { t } = useTranslation()

  const dragStart = () => {
    setMovedItemData(index, -1, false, true, item.id)
  }

  const dragOver = e => {
    e.preventDefault()
    setMovedItemData(-1, index, false, true, item.id)
  }

  const dragEnd = e => {
    e.preventDefault()
    setMovedItemData(-1, -1, true, false, item.id)
  }

  return (
    <Box
      flexDirection={'row'}
      sx={{ pb: 1, height: '60px' }}
      onDragStart={dragStart}
      onDragOver={dragOver}
      onDragEnd={dragEnd}
      draggable={itemCount > 1 && hasFullPermission('student.contact')}
    >
      <Grid container spacing={2}>
        {itemCount > 1 && (
          <Grid item xs={0.5} md={0.5}>
            <Box sx={{ cursor: 'move' }}>
              <DragIndicatorIcon />
            </Box>
          </Grid>
        )}

        <Grid item xs={itemCount > 1 ? 1.5 : 2}>
          {item.relationship.slice(0, 1).toUpperCase()}
          {item.relationship.slice(1)}
        </Grid>
        <Grid item xs={2.5} md={2.5}>
          <Link component={NavLink} underline="hover" color="inherit" to={`${item.id}`}>
            {item.contact.title && item.contact.title} {item.contact.firstName} {item.contact.middleName}{' '}
            {item.contact.lastName}
          </Link>
        </Grid>
        <Grid item xs={2}>
          {item.contact?.phones[0]?.number ? (
            <Chip
              icon={
                item.contact.phones[0]?.type === 'home' ? (
                  <HomeIcon />
                ) : item.contact.phones[0]?.type === 'mobile' ? (
                  <PhoneIphoneIcon />
                ) : item.contact.phones[0]?.type === 'work' ? (
                  <WorkIcon />
                ) : (
                  <PhoneIcon />
                )
              }
              label={item.contact.phones[0]?.number}
            />
          ) : (
            <FeildSkeleton />
          )}
        </Grid>

        {item.pickup && (
          <Grid item xs={2}>
            <Chip icon={<CheckCircleOutlineIcon />} label={t('Pickup')} color="success" />
          </Grid>
        )}

        {!item.pickup && (
          <Grid item xs={2}>
            <Chip icon={<CloseIcon />} label={t('Pickup')} color="error" />
          </Grid>
        )}

        {item.emergency && (
          <Grid item xs={2}>
            <Chip icon={<CheckCircleOutlineIcon />} label={t('Emergency Call')} color="success" />
          </Grid>
        )}
        {!item.emergency && (
          <Grid item xs={2}>
            <Chip icon={<CloseIcon />} label={t('Emergency Call')} color="error" />
          </Grid>
        )}
        {hasFullPermission('student.contact') && (
          <Grid item sx={{ textAlign: 'right' }} xs={1.5} >
            <Button color="primary" size="small" component={NavLink} variant="outlined" to={`${item.id}`}>
              {t('Edit')}
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}
